import { Component, OnInit, OnDestroy, ViewChild, ElementRef   }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {IGrowthRatesSave} from './growth-rates-save';
import {GrowthRatesSaveService} from './growth-rates-save.service';
import { UserSession } from '../../../shared/user-session';
import { UserInfoService } from '../../../shared/user-info.service';
import { IScenario, ScenarioService } from '../../../scenario-activities/scenario.service';

import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';

@Component({
    //templateUrl: 'app/system-management/growth-rates/growth-rates-save/growth-rates-save.component.html',
    template: require('./growth-rates-save.component.html'),
    styles: [require('../../../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES, Dialog, Messages],
    providers:[GrowthRatesSaveService]
    
})

export class GrowthRatesSaveComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Growth Rates Save ';
    errorMessage: string;
    private sub: any;
    growthRatesSaveResult: IGrowthRatesSave;
    displaySpinner :boolean=false;
    msgs: Messages[]=[];
    allScenarios: IScenario[];
    isScenarioOwner: boolean = false;
    scenarioHeaderDiv: HTMLDivElement;
    currentScenario: IScenario;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _growthRatesService:GrowthRatesSaveService,             
                private _scenarioService: ScenarioService,
                private User: UserSession,
                private _userInfoService: UserInfoService) {
        this.growthRatesSaveResult = new IGrowthRatesSave("");                
    }
    
    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;
    ngOnInit(): void{
        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
        );
        
        //this probably needs to be somewhere more central
        this.User.updateSessionState();
        
        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );


      this.displaySpinner = true;
      this._growthRatesService.getSavedRatesResponse(this.User.getSession().scenarioId)
          .subscribe( growthRatesSaveResult => {
                    this.growthRatesSaveResult = growthRatesSaveResult;
                    if( this.growthRatesSaveResult.message.indexOf("Error")>=0){
                        this.displaySpinner = false;
                        this.msgs.push({severity:'error', summary:'Error Message', detail: this.growthRatesSaveResult.message});
                        console.error( this.growthRatesSaveResult.message);
                    }
                    else{
                        this.displaySpinner = false;
                        this.msgs.push({severity:'info', summary:'Info Message', detail: this.growthRatesSaveResult.message});
                    }
                },
                error => {
                    this.displaySpinner = false;
                    this.errorMessage = "An error occured while trying to update the facility.";
                    this.msgs.push({severity:'error', summary:'Error Message', detail: this.errorMessage});
                    console.error(error);
                });
    }
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }
    
    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/growth-rates/growth-rates-save/growth-rates-save.component.ts
 **/